module.exports = __webpack_public_path__ + "img/cadet_schooluniform_7-7-2021.a1f25303.jpg";